module.exports = __webpack_public_path__ + "img/9.f64c1281.jpg";